import { render, staticRenderFns } from "./aportaciones.vue?vue&type=template&id=470701e8&"
import script from "./aportaciones.vue?vue&type=script&lang=js&"
export * from "./aportaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports